.band {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px 18px;
}

/* The figure and its chips on the left, the three tiles on the right; at a narrow width the tiles drop
   under the figure. */
.ready {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 14px 24px;
}

.heroLeft {
  display: flex;
  flex: 1 1 300px;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  min-width: 0;
}

/* The tiles keep their own width and the figure's chips wrap to make room; below about 1000px the tiles
   drop under the figure. */
.ready > section {
  flex: 0 1 600px;
}

.big {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.percent {
  margin: 0;
  color: var(--ink);
  font-size: 40px;
  font-weight: 700;
  line-height: 1;
  font-variant-numeric: lining-nums tabular-nums;
}

.percentLabel {
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 600;
}

.verdict {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.chipButton {
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: 0;
  border-radius: var(--radius-pill);
  background: none;
  cursor: pointer;
}

.chipButton:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.note {
  margin: 0;
  color: var(--ink);
  font-size: var(--t-body);
  line-height: 1.5;
}

.views {
  flex: 0 0 auto;
}

/* What to do, and under it what is wrong. */
.todoWhat {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.todoReason {
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 500;
}

/* A fix that is a drawer on this filing is a button that reads as the link beside it. */
.fixButton {
  padding: 0;
  border: 0;
  background: none;
  color: var(--accent);
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 600;
  text-align: left;
  text-decoration: underline;
  text-decoration-color: var(--accent-line);
  text-underline-offset: 2px;
  cursor: pointer;
}

.fixButton:hover {
  text-decoration-color: currentcolor;
}

.fixButton:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.actionRow {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: var(--h-ctl);
  padding: 0 12px;
  border: 1px solid var(--line);
  border-radius: var(--radius-ctl);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}

.button:hover:not(:disabled) {
  background: var(--panel-2);
}

.button:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.button:disabled {
  color: var(--disabled);
  cursor: not-allowed;
}

.drawerList {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.drawerList li {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.fix {
  font-size: var(--t-dense);
  font-weight: 600;
}

.refused {
  color: var(--muted);
  font-size: var(--t-dense);
}

.rowLink {
  background: none;
  border: 0;
  padding: 0;
  color: var(--accent);
  font: inherit;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
}

.compact {
  min-width: 260px;
}

.past {
  display: flex;
  flex-direction: column;
  gap: var(--gap);
  min-width: 0;
}
